import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getLocalAccessToken, setIsAccessAllowed, setTokens, setUser } from '../../services/localStorage';
import { fetchSingleUser, getAccessToken, getUserInfo } from '../../common/jsonstore';
import { AppDispatch } from '../../redux/store/store';
import { handleError } from '../../services/messageApiService';

export interface IAuthentication {
  isProcessingComplete: boolean;
  isTokenSet: boolean;
  isUserInfoSet: boolean;
  isAccessAllowed: boolean;
  userSgid: string
}
const initialState: IAuthentication = { isProcessingComplete: false, isTokenSet: false, isUserInfoSet: false, isAccessAllowed: false, userSgid: "" };
export const authenticationSlice = createSlice({
  name: 'authentication',
  initialState,
  reducers: {
    access_token: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        isProcessingComplete: false,
        isTokenSet: true
      };
    },
    user_info: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        isProcessingComplete: false,
        isTokenSet: false,
        isUserInfoSet: true,
        userSgid: action.payload.stGoSGI
      };
    },
    loggedinUser: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        isProcessingComplete: true,
        isAccessAllowed: action.payload
      };
    },
    error: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        isProcessingComplete: false,
        isTokenSet: false,
        isUserInfoSet: false
      };
    },
  },
});

export const loadSingleUser = (user_sgid: string): any => async (dispatch: AppDispatch) => {
  const res = await fetchSingleUser(user_sgid);
  if (res.length > 0) {
    dispatch(authenticationSlice.actions.loggedinUser(true))
    setIsAccessAllowed(true)
    setUser(res[0]);
  } else {
    dispatch(authenticationSlice.actions.loggedinUser(false))
    setIsAccessAllowed(false)
  }
}
export const loadToken = (url: string): any => async (dispatch: AppDispatch) => {
  const res = await getAccessToken(url);
  if (res.access_token) {
    await setTokens(res).then(res => {
      console.log("gettkn",getLocalAccessToken())
      dispatch(authenticationSlice.actions.access_token(res))
    }).catch(err => {
      handleError('Something happened');
    })
  }
}

export const loadUserInfo = (url: string): any => async (dispatch: AppDispatch) => {
  const res = await getUserInfo(url);
  dispatch(authenticationSlice.actions.user_info(res))
}
export const { access_token, user_info, error } = authenticationSlice.actions;
// export const selectAuthentication = (state: AppState) => state.authentication;
export const authenticationReducer = authenticationSlice.reducer;
export default authenticationReducer;

